import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { getNewsItem } from "../lib/api";
import { NEWS_FALLBACK } from "../lib/api";
import { Seo } from "../components/Seo";
import { ArrowLeft, ArrowUpRight } from "lucide-react";

const formatDate = (iso) => {
  try {
    return new Date(iso).toLocaleDateString("tr-TR", { day: "numeric", month: "long", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch { return ""; }
};

const NewsDetail = () => {
  const { id } = useParams();
  const [item, setItem] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => { getNewsItem(id).then(setItem).catch(() => setNotFound(true)); }, [id]);

  if (notFound)
    return (
      <div className="mx-auto max-w-3xl px-4 py-24 text-center">
        <h1 className="font-display text-2xl font-semibold text-ink">Haber bulunamadı</h1>
        <Link to="/borsa-haberleri" className="mt-4 inline-flex items-center gap-2 text-claret"><ArrowLeft size={16} /> Haberlere dön</Link>
      </div>
    );

  if (!item) return <div className="px-4 py-24 text-center text-muted-foreground">Yükleniyor...</div>;

  return (
    <article className="mx-auto max-w-3xl px-4 sm:px-6 py-10 paper-texture" data-testid="news-detail">
      <Seo title={`${item.title} | Borsa Haberleri`} description={(item.summary || "").slice(0, 155)} path={`/borsa-haberleri/${item.id}`} image={item.image_url}
        jsonLd={{ "@context": "https://schema.org", "@type": "NewsArticle", headline: item.title, image: item.image_url ? [item.image_url] : undefined, datePublished: item.published_at, articleBody: item.summary, publisher: { "@type": "Organization", name: "SPK Aracı Kurumlar" } }} />
      <Link to="/borsa-haberleri" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-ink"><ArrowLeft size={16} /> Borsa Haberleri</Link>

      <span className="kicker mt-6 block text-claret">{item.source}</span>
      <h1 className="mt-3 border-b-2 border-ink pb-5 font-display text-3xl font-semibold leading-tight tracking-tight text-ink sm:text-[2.6rem]">{item.title}</h1>
      <div className="mt-3 text-xs text-muted-foreground">{formatDate(item.published_at)}</div>

      <div className="mt-6 overflow-hidden border border-ink">
        <img src={item.image_url} alt={item.title} referrerPolicy="no-referrer" onError={(e) => { if (e.currentTarget.src !== NEWS_FALLBACK) e.currentTarget.src = NEWS_FALLBACK; }} className="w-full object-cover" />
      </div>

      <p className="drop-cap mt-7 whitespace-pre-line font-display text-lg leading-[1.85] text-ink/90">{item.summary}</p>

      {item.source_url && (
        <a href={item.source_url} target="_blank" rel="noopener noreferrer"
          className="mt-8 inline-flex items-center gap-1.5 rounded-sm border border-ink px-5 py-2.5 text-sm font-semibold text-ink hover:bg-ink hover:text-paper" data-testid="news-source-link">
          Kaynağı görüntüle <ArrowUpRight size={14} />
        </a>
      )}

      <p className="mt-8 border-l-2 border-claret bg-tint/60 p-4 text-xs leading-relaxed text-muted-foreground">
        Bu haber, güvenilir kaynaklardan otomatik olarak derlenip yapay zeka ile özetlenmiştir. Yatırım tavsiyesi niteliği taşımaz.
      </p>
    </article>
  );
};

export default NewsDetail;
